export default __webpack_public_path__ + "static/media/IotDisconnected.b570aa6a.svg";